// extracted by mini-css-extract-plugin
export default {"container":"wR7PET","text":"DxQ8C1","clamp":"BOlnTh"};